import { render, staticRenderFns } from "./EmptyTabFallback.vue?vue&type=template&id=737fc755&scoped=true"
import script from "./EmptyTabFallback.vue?vue&type=script&lang=js"
export * from "./EmptyTabFallback.vue?vue&type=script&lang=js"
import style0 from "./EmptyTabFallback.vue?vue&type=style&index=0&id=737fc755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737fc755",
  null
  
)

export default component.exports